<template>
    <form class="hidden-print contact-form voucher-form"
        @submit.prevent="submit">


        <div class="form-horizontal">

            <div class="alert alert-info"
                v-show="status=='done'">
                <button type="button"
                    class="voucher-close"
                    aria-hidden="true"
                    @click="status='ready'">&times;</button>

                <span>{{voMsg('voucher.success',[voucher && voucher.code])}}</span>
            </div>

            <div class="alert alert-warning"
                v-show="status=='failed'">
                <span>{{voMsg('tpl.voucherfailed')}}</span>
            </div>



            <div v-show="status=='ready' || status=='failed'">

                <div class="form-group row">
                    <div class="col-sm-12">
                        <label for="input_code_voucher"
                            class="sr-only">{{voMsg('tpl.text.enterVoucherCode')}}</label>
                        <input type="text"
                            class="form-control voucher-input"
                            id="input_code_voucher"
                            v-model="reqCode"
                            required="required">
                    </div>
                </div>
                <button type="submit"
                    class="btn btn-go w-100 mt-2">
                    {{submitLabel}}
                </button>

            </div>

            <div class="contact-sending"
                v-show="status=='submitting'"
                ng-cloak>
                <div class="spinner">
                    <div class="bounce1"></div>
                    <div class="bounce2"></div>
                    <div class="bounce3"></div>
                </div>

            </div>

            <voffice-error-message :error="error"></voffice-error-message>


        </div>
    </form>

</template>


<script>
    import V from 'voUtils/V.js'

    import {
    	doPost
    }
    from 'voUtils/RestEx.js';

    import {
    	formatMsg
    }
    from 'voUtils/voI18n.js'

    import {
    	setVoucher, getVoucher
    }
    from 'voUtils/VoucherStore.js'

    var voucher = getVoucher();

    export default {
    	voVueComponent: 'voffice-voucher',
    	props: {
    		voucherOkMsg: String,
    		voucherFailedMsg: String,
    		voucherCodeLabel: String,
    		submitLabel: String
    	},
    	data() {
    		return {
    			error: undefined,
    			reqCode: undefined,
    			status: voucher ? 'done' : 'ready',
    			voucher: voucher
    		}
    	},
    	mounted: function() {
    		//console.log('Mounted-Voucher');
    		const sessionDuration = 60 * 60 * 1000;
    		const now = Date.now();
    		const voucherTimestamp = localStorage.getItem('voucherTimestamp');
    		if (!voucherTimestamp || now - voucherTimestamp > sessionDuration) {
    			this.removeVoucher();
    		}
    	},
    	methods: {
    		removeVoucher: function() {
    			localStorage.removeItem("voucher_name");
    			localStorage.removeItem("voucher_validated");
    			localStorage.removeItem("voucher_code");
    			this.status = 'ready';
    		},
    		submit: function() {

    			this.status = 'submitting';
    			const now = Date.now();

    			var req = {
    				code: this.reqCode
    			};

    			voucher = undefined;

    			//console.log("req:", req);

    			doPost('validateVoucher', req)
    				.then(res => {

    					if (res.voucher) {
    						res.voucher.code = req.code;

    						this.voucher = res.voucher;
    						setVoucher(this.voucher);
    						localStorage.setItem('voucherTimestamp', now);

    						this.status = 'done';


    					} else {
    						this.status = 'failed';
    					}


    				})
    				.catch(e => {
    					this.status = 'ready';
    					this.error = e;
    				})


    		}
    	}

    };
</script>
<style scoped>
    .voucher-form {
    	max-width: 600px;
    }
</style>